// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transfer-row {
  border: 2px solid #28a745;
  background-color: #f8fff8;
}

.date-input {
  width: 150px;
}

.remove-btn {
  border: 1px solid #dc3545;
  border-radius: 4px;
  padding: 6px 12px;
}

.add-button {
  text-decoration: none;
}

.total-input {
  background-color: #f8f9fa;
  color: #6c757d;
}

.submit-button {
  border-radius: 8px;
  padding: 12px 40px;
  font-size: 16px;
  font-weight: 500;
}

.bg-light.rounded {
  max-width: 824px;
  padding: 35px !important;
  margin: 0 auto !important;
}

.bg-light.rounded .d-flex.justify-content-between > div:first-child {
  text-align: left !important;
}

.bg-light.rounded .d-flex.justify-content-between > div:first-child h4,
.bg-light.rounded .d-flex.justify-content-between > div:first-child h6 {
  text-align: left !important;
}

.form-label {
  font-size: 12px !important;
}

.form-control,
.form-select {
  font-size: 13px !important;
  padding: 6px 12px !important;
}

.card-title {
  font-size: 14px !important;
}

.btn {
  font-size: 13px !important;
}

`, "",{"version":3,"sources":["webpack://./src/Pages/HGO/Dashboard/ReversalAccumulativeRequest/ReversalAccumulativeRequest.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".transfer-row {\n  border: 2px solid #28a745;\n  background-color: #f8fff8;\n}\n\n.date-input {\n  width: 150px;\n}\n\n.remove-btn {\n  border: 1px solid #dc3545;\n  border-radius: 4px;\n  padding: 6px 12px;\n}\n\n.add-button {\n  text-decoration: none;\n}\n\n.total-input {\n  background-color: #f8f9fa;\n  color: #6c757d;\n}\n\n.submit-button {\n  border-radius: 8px;\n  padding: 12px 40px;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.bg-light.rounded {\n  max-width: 824px;\n  padding: 35px !important;\n  margin: 0 auto !important;\n}\n\n.bg-light.rounded .d-flex.justify-content-between > div:first-child {\n  text-align: left !important;\n}\n\n.bg-light.rounded .d-flex.justify-content-between > div:first-child h4,\n.bg-light.rounded .d-flex.justify-content-between > div:first-child h6 {\n  text-align: left !important;\n}\n\n.form-label {\n  font-size: 12px !important;\n}\n\n.form-control,\n.form-select {\n  font-size: 13px !important;\n  padding: 6px 12px !important;\n}\n\n.card-title {\n  font-size: 14px !important;\n}\n\n.btn {\n  font-size: 13px !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
